import { differenceInCalendarDays, format as formatDate, parse as parseDate } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

const DATE_FORMAT_STR_FOR_TRAVELLERS = 'dd/MM/yyyy';

function getLocalTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function convertDateToUTC(date: string, timezone?: string) {
  if (!timezone) {
    timezone = getLocalTimeZone();
  }

  return fromZonedTime(new Date(date), timezone);
}

// Format 'Date' (or) date 'string' to assign to form field.
function formatDateForForm(date: string | number | Date) {
  return formatDate(date, 'yyyy-MM-dd');
}

// Format 'Date' (with) time data to assign to form field.
function formatTimeForForm(time: string | number | Date) {
  return formatDate(time, 'HH:mm');
}

// Format 'Date' (or) date 'string' in policy for display.
function formatDateInPolicy(date: string | number | Date) {
  return formatDate(date, 'dd LLL yyyy');
}

// Format 'Date' (or) date 'string' to assign to a policy.
function formatDateForPolicy(date: string | number | Date) {
  return formatDate(date, 'yyyy-MM-dd');
}

// Format 'Date' (or) date 'string' in claim for display.
function formatDateInClaim(date?: string | number | Date) {
  return date ? formatDate(date, 'dd MMMM yyyy') : '';
}

// Format 'Date' (or) date 'string' to assign to a claim.
function formatDateForClaim(date?: string | number | Date) {
  return date ? new Date(date).toISOString() : '';
}

function formatDateInTravellers(date: string | number | Date) {
  return formatDate(date, DATE_FORMAT_STR_FOR_TRAVELLERS);
}

function parseDateForTravellers(date: string) {
  return parseDate(date, DATE_FORMAT_STR_FOR_TRAVELLERS, new Date());
}

function getHasBeen20DaysSince(date: string | number | Date) {
  return differenceInCalendarDays(new Date(), date) > 20;
}

export { compareDesc as compareDatesDesc, differenceInDays } from 'date-fns';
export {
  convertDateToUTC,
  formatDateForClaim,
  formatDateForForm,
  formatDateForPolicy,
  formatDateInClaim,
  formatDateInPolicy,
  formatDateInTravellers,
  formatTimeForForm,
  getHasBeen20DaysSince,
  getLocalTimeZone,
  parseDateForTravellers,
};
